// import { authRoles } from './auth/authRoles'

import { AuthRoles } from "../../Component/Auth/AuthRoles";

export const navigations = [
    {
        name: 'Dashboard',
        path: '/dashboard',
        icon: 'dashboard',
        auth: AuthRoles.admin,
    },
    {
        name: 'Admin',
        path: '/admin',
        icon: 'supervisor_account',
        auth: AuthRoles.sa,
    },
    {
        name: 'Product',
        path: '/product',
        icon: 'favorite',
        auth: AuthRoles.editor,
    },
    {
        name: 'Orders',
        path: '/orders',
        icon: 'shopping_cart',
        auth: AuthRoles.editor,
    },
    {
        name: 'Delivery',
        path: '/delivery',
        icon: 'local_shipping',
        auth: AuthRoles.editor,
    },
    {
        name: 'Chat',
        path: '/chat',
        icon: 'forum',
        auth: AuthRoles.editor,
    },
    {
        name: 'Marketing',
        path: '/marketing',
        icon: 'store',
        auth: AuthRoles.editor,
    },
    {
        name: 'Leads',
        path: '/leads',
        icon: 'dashboard_customize',
        auth: AuthRoles.editor,
    },
    {
        name: 'Tickets',
        path: '/tickets',
        icon: 'stars',
        auth: AuthRoles.editor,
    },
    {
        name: 'Contents',
        path: '/contents',
        icon: 'business_center',
        auth: AuthRoles.editor,
    },
    {
        name: 'Log',
        path: '/log',
        icon: 'notifications',
        auth: AuthRoles.editor,
    },
    {
        name: 'Settings',
        path: '/settings',
        icon: 'settings',
        auth: AuthRoles.editor,
    },
    {
        name: 'Helps',
        path: '/helps',
        icon: 'help_outline',
        auth: AuthRoles.editor,
    },
    {
        label: 'Pages',
        type: 'label',
        auth: AuthRoles.guest,
    },
    {
        name: 'Auth Pages',
        icon: 'security',
        auth: AuthRoles.guest,
        children: [
            {
                name: 'Log in',
                iconText: 'SI',
                path: '/session/login',
                
            },
            {
                name: 'Sign up',
                iconText: 'SU',
                path: '/session/signup',
            },
            {
                name: 'Forgot Password',
                iconText: 'FP',
                path: '/session/forgot-password',
            },
            {
                name: 'Error',
                iconText: '404',
                path: '/session/404',
            },
        ],
    },
]
